import type { FacilityWorkflowPayload } from '@Application/Facilities/Workflows/Actions/facilityWorkflowsFetched';
import FacilityWorkflowAutomaticSourceView from '@UI/Store/FacilityWorkflows/Views/FacilityWorkflowAutomaticSourceView';
import FacilityWorkflowStageView from '@UI/Store/FacilityWorkflows/Views/FacilityWorkflowStageView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A group of documents proposed in the facility. `key` is the identifier stable between versions.
 */
class FacilityWorkflowView {
	readonly key: string;
	readonly label: string;
	readonly description: string | null;
	readonly requiresValidationBeforeNext: boolean;
	readonly stages: readonly FacilityWorkflowStageView[];
	readonly automaticSources: readonly FacilityWorkflowAutomaticSourceView[];

	constructor(payload: FacilityWorkflowPayload) {
		this.key = payload.key;
		this.label = payload.label;
		this.description = payload.description;
		this.requiresValidationBeforeNext = payload.requiresValidationBeforeNext;
		this.stages = payload.stages.map((stage) => new FacilityWorkflowStageView(stage));
		this.automaticSources = payload.automaticSources.map(
			(source) => new FacilityWorkflowAutomaticSourceView(source),
		);

		Object.freeze(this);
	}
}

export default FacilityWorkflowView;
